import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MensagensAplicacaoService } from './mensagens.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [MensagensAplicacaoService],
})
export class ConstantesModule {}
